import { PromotionsService } from '../services';
import { usePromotionPayoutsQuery } from './usePromotionPayoutsQuery';

export const getProfessionalPromotionPayoutsQueryKey = (professionalId) => [
  'GET_PROFESSIONAL_PROMOTION_PAYOUTS',
  professionalId,
];

export const useGetProfessionalPromotionPayouts = (professionalId, options) =>
  usePromotionPayoutsQuery(
    getProfessionalPromotionPayoutsQueryKey(professionalId),
    () => PromotionsService.getProfessionalPromotionPayouts(professionalId),
    { enabled: options?.enabled ?? !!professionalId },
  );
